export default () => ({
  gridIndex: 0,

  changeGrid(index) {
    if (index !== this.gridIndex) {
      this.gridIndex = index;
    }
  },
});
